import React from "react";
import { Helmet } from "react-helmet";
import { Image, Layout, Typography } from "antd";
import { ImageUrl } from "../../helpers/Functions";
import "./about-us.css";

function AboutUs() {
  return (
    <div className="about-page">
      <Helmet>
        <title>Early Education Management & Facility Consulting Services</title>
        <meta
          name="description"
          content="Expert consulting for early education, offering tailored early childhood facility services and effective program management to enhance educational environments."
        />
        <meta
          property="og:title"
          content="Early Education Management & Facility Consulting Services"
        />
        <meta
          property="og:description"
          content="Expert consulting for early education, offering tailored early childhood facility services and effective program management to enhance educational environments."
        />
      </Helmet>

      <Layout className="about-layout">
        <section
          className="about-hero"
          style={{ backgroundImage: `url(${ImageUrl("aboutus-banner-new.png")})` }}
        >
          <div className="about-hero-overlay" aria-hidden />
          <div className="about-wrap about-hero-inner">
            <div className="about-hero-copy">
              <span className="about-hero-badge">WRIGHTCO ACADEMY</span>
              <Typography.Title className="fontFamily1 about-hero-title" level={1}>
                About Us
              </Typography.Title>
              <Typography.Paragraph className="fontFamily1 about-hero-lead">
                We are consultants, and trainers.
                <br />
                This is an online learning community.
              </Typography.Paragraph>
            </div>
          </div>
        </section>

        <section className="about-wrap about-main">
          <div className="about-grid">
            <article className="about-content-card">
              <Typography.Paragraph className="fontFamily1 about-section-text">
                WrightCo Academy&apos;s mission is to inspire and develop organizations and their
                staff to achieve continues quality improvement goals— one person, one question,
                and one small commitment to learning at a time.
              </Typography.Paragraph>
              <Typography.Paragraph className="fontFamily1 about-section-text">
                We enable a great team of subject matter experts, practitioners and facilitators
                experienced in Head Start, Early Head Start, Day Care and Family Childcare, to
                provide an interactive learning experience. Our courses explore laws and regulatory
                compliance that shape early care and education program governance and design, human
                resources, facility management and health and safety into a delightful experience
                of guided discovery.
              </Typography.Paragraph>
            </article>

            <div className="about-image-frame">
              <Image
                preview={false}
                alt="WrightCo Academy — about"
                className="about-image"
                src={ImageUrl("new-4.png")}
              />
            </div>
          </div>
        </section>
      </Layout>
    </div>
  );
}

export default AboutUs;
